import {AxiosResponse} from 'axios';
import Api from './Api';

export default class Saque {
  public static async get(request?: IRequestOptions): Promise<GetSaquesResponse> {
    const response = await Api.instance.get<GetSaquesResponse>('/saques', {
      params: request?.params,
    });
    return response.data;
  }

  public static async post(request?: IRequestOptions): Promise<PostSaquesResponse> {
    const response = await Api.instance.post<PostSaquesResponse>('/saques', {
      params: request?.params,
    });
    return response.data;
  }

  public static async exportar(request?: IRequestOptions): Promise<AxiosResponse<string>> {
    return await Api.instance.get<string>(`/saques`, {params: request?.params});
  }

  public static async getByID(id: number): Promise<GetSaqueResponse> {
    const response = await Api.instance.get<GetSaqueResponse>(`/saques/${id}`);
    return response.data;
  }

  public static async getComissoes(
    id: number,
    request?: IRequestOptions
  ): Promise<GetComissoesResponse> {
    const response = await Api.instance.get<GetComissoesResponse>(`/saques/${id}/comissoes`, {
      params: request?.params,
    });
    return response.data;
  }

  public static async patch(id: number, data: PatchSaqueRequest): Promise<PatchSaqueResponse> {
    const response = await Api.instance.patch<PatchSaqueResponse>(`/saques/${id}`, data);
    return response.data;
  }

  public static async excluir(id: number): Promise<GenericResponse> {
    const response = await Api.instance.delete<GenericResponse>(`/saques/${id}`);
    return response.data;
  }

  public static async getComprovantes(
    id: number,
    request?: IRequestOptions
  ): Promise<GetComprovantesResponse> {
    const response = await Api.instance.get<GetComprovantesResponse>(`/saques/${id}/comprovantes`, {
      params: request?.params,
    });
    return response.data;
  }

  public static async excluirComprovante(saque: number, id: number): Promise<GenericResponse> {
    const response = await Api.instance.delete<GenericResponse>(`/saques/${saque}/comprovantes/${id}`);
    return response.data;
  }

  public static async getAnexos(
    id: number,
    request?: IRequestOptions
  ): Promise<GetComprovantesResponse> {
    const response = await Api.instance.get<GetComprovantesResponse>(`/saques/${id}/anexos`, {
      params: request?.params,
    });
    return response.data;
  }

  public static async excluirAnexos(saque: number, id: number): Promise<GenericResponse> {
    const response = await Api.instance.delete<GenericResponse>(`/saques/${saque}/anexos/${id}`);
    return response.data;
  }

  public static async criarObservacao(saque: number, data: PostObservacaoRequest): Promise<GenericResponse> {
    const response = await Api.instance.post<GenericResponse>(`/saques/${saque}/observacoes`, data);
    return response.data;
  }
}
